import { render, staticRenderFns } from "./InventorySectorLabelComponent.vue?vue&type=template&id=4399ce71"
import script from "./InventorySectorLabelComponent.vue?vue&type=script&lang=js"
export * from "./InventorySectorLabelComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports